/**
 * Shared in-page anchor resolution for CCLP smooth-scroll handlers.
 * Supports semantic ids (e.g. #buybox), legacy #shopify-section-{key}, and OS 2.0
 * section wrappers (shopify-section-template--*__{key}).
 */
(function () {
  function findScrollTarget(hashId) {
    if (!hashId) return null;

    var el = document.getElementById(hashId);
    if (el) return el;

    var sectionKey = hashId;
    if (hashId.indexOf('shopify-section-') === 0) {
      sectionKey = hashId.slice('shopify-section-'.length);
    }

    el = document.querySelector('[id^="shopify-section-"][id$="__' + sectionKey + '"]');
    if (el) return el;

    return document.getElementById('shopify-section-' + sectionKey);
  }

  window.CclpScrollTarget = { find: findScrollTarget };
})();
